import React, { Component }  from 'react';
import { connect }           from 'react-redux';
import { Link }                from 'react-router-dom';
import FlashRetornoNulo      from '../../../../container/FlashRetornoNulo';
import {SetExcluirQuestao}  from '../../../../actions/atividadesAction';
import { SetError }          from '../../../../actions/notificacaoAction';

class QuizQuestaoList extends Component {

    excluirQuestaoQuiz(que_id){
        const acao  = window.confirm("Deseja Remover?");
        if(acao) {
           this.props.SetExcluirQuestao(que_id)
        }
    }

    renderQuestao(){

        const lista = this.props.all_questao;
        const acao  = {width:'10%'}
       
        if (lista.length !==0) {
           
            return lista.map((elem,i)=>{

                return  <tr key={i}>
                            <td className="text-center">{elem.ati_que_pergunta}</td>
                            <td className="text-center" style={acao}>

                             <Link to={`${this.props.menu.desafios.desafioquizaction}/${this.props.que_id}/${elem.ati_que_id}`} className="btn btn-warning btn-xs">
                                  <span className="glyphicon glyphicon-pencil"></span>
                            </Link>
                            </td>   
                            <td className="text-center" style={acao}>
                            <button className="btn btn-danger btn-xs" onClick={this.excluirQuestaoQuiz.bind(this,elem.ati_que_id)}>
                                <span className="glyphicon glyphicon-remove-sign"></span>
                            </button>
                            </td>
                        </tr> 
            });

        } else {
           
            return <tr> <td colSpan={3} className="text-center"><FlashRetornoNulo/></td></tr>;
        }   
    }

    render() {        
  
        return (
                <div>
                <div className="panel panel-azul-claro panel-cinza">
                   <div className="panel-body">
                         <table className="table table_panel">
                            <thead>
                               <tr>
                                  <th className="text-center">Pergunta</th>
                                  <th className="text-center">Editar</th>
                                  <th className="text-center">Excluir</th>
                               </tr>
                            </thead>
                            <tbody> 
                               {this.renderQuestao()}
                            </tbody>
                         </table>
                   </div>
                </div>
             </div>
        );
    }
}

function mapStateToProps(state){
    
        return {
          menu      : state.configReducer.menu,
          turma       : state.atividadesReducer.turma,
          titulo      : state.atividadesReducer.titulo,
          disciplina  : state.atividadesReducer.disciplina,
          all_questao : state.atividadesReducer.fetch_all_questao        
        }
    }

export default connect(mapStateToProps,{SetExcluirQuestao,SetError})(QuizQuestaoList);



// WEBPACK FOOTER //
// ./src/components/professor/desafios/quiz/desafios_quiz_list.js